export default __webpack_public_path__ + "static/media/liel-eli.22888b7a.png";